<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ChevronDown } from 'lucide-vue-next';
import type { AccordionTriggerProps } from 'reka-ui';
import { AccordionHeader, AccordionTrigger } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<
    AccordionTriggerProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
    <AccordionHeader class="flex">
        <AccordionTrigger
            data-slot="accordion-trigger"
            v-bind="delegatedProps"
            :class="
                cn(
                    'focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 cursor-pointer items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-semibold transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180',
                    props.class
                )
            "
        >
            <slot />
            <slot name="icon">
                <ChevronDown
                    class="text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200"
                />
            </slot>
        </AccordionTrigger>
    </AccordionHeader>
</template>
